import { render } from "./Retailer.vue?vue&type=template&id=39ddf7a5&ts=true"
import script from "./Retailer.vue?vue&type=script&lang=ts"
export * from "./Retailer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__